// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type MyListsFiltersState = Readonly<{
    sharedBy: string;
    product: string;
    brand: string;
}>;

const initialState: MyListsFiltersState = {
    sharedBy: "",
    product: "",
    brand: "",
};

const reducer = {
    "xMyListsFilterText/SetText": (draft: Draft<MyListsFiltersState>, action: { filterType: string; text: string }) => {
        if (action.filterType === "clear") {
            draft.sharedBy = "";
            draft.product = "";
            draft.brand = "";
            return;
        }
        draft[action.filterType as keyof MyListsFiltersState] = action.text;
    },
};

const xMyListsFilters = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xMyListsFilters = xMyListsFilters;

export type xMyListsFiltersState = {
    xMyListsFilters: MyListsFiltersState;
} & ApplicationState;

type MyListsFiltersReducers = {
    query: typeof xMyListsFilters;
};

export type xMyListsFilters = Parameters<MyListsFiltersReducers[keyof MyListsFiltersReducers]>[1] | AnyAction;
